
<section class="sg-container newsUpdateDialog">
    <form [formGroup]="massCommunicationForm" novalidate autocomplete="off">
        <div class="row m-0 border-bottom p-3">
            <h1 mat-dialog-title class="col-11 mb-0 pl-2">New Mass Communication Email</h1>           
            <span class="col-1 material-icons-outlined sg-mass-close-icon pl-5 pointer-cursor">
                <p  (click)="onCancelClick()"> close</p>
            </span>
        </div>
        <main mat-dialog-content class="sg-dialog-content py-3">
            <div class="row">
                <div class="col-2 pt-3 pr-0 sg-field-label-align">
                    <label class="sg-form-field-label">Roles<span class="sg-form-field-required-marker ml-1">*</span>
                    </label>
                    <span class="sg-infoIcon icon-position">
                        <p class="material-icons-outlined py-0 my-0" [tooltip]="template" contentType="template"
                            [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline</p>
                        <ng-template #template class="w-100">
                            <div class="row mx-0 w-100">
                                <div class="col-12 w-100 px-0">
                                    <span>Select the user roles that will receive the Mass Communications Email
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                    </span>
                </div>
                <div class="col-4 pt-1 px-0">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select class="sg-mass-role" multiple formControlName="userRoles">
                            <mat-option *ngFor="let option of roles" [value]="option">
                                {{ option.roleName }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="massCommunicationForm.controls.userRoles.errors?.required">
                            This is required Field.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
         
           <div class="row">
                <div class="col-2 pt-2 pr-0">
                    <label class="sg-form-field-label">Subject</label>
                    <span class="sg-form-field-required-marker ml-1">*</span>
                </div>
                <div class="col-10 px-0">
                    <mat-form-field appearance="outline" class="w-100 sg-validation">
                        <input matInput type="text" formControlName="subject">
                        <mat-error *ngIf="massCommunicationForm.controls.subject.errors?.required">
                            This is required Field.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-2 pt-3 pr-0">
                    <label class="sg-form-field-label">Body</label>
                    <span class="sg-form-field-required-marker ml-1">*</span>
                </div>
                <div class="col-10 pt-3 px-0">
                    <mat-form-field appearance="outline" class="w-100 sg-validation">
                        <textarea matInput type="text" rows="12" cols="70" formControlName="body"></textarea>
                        <mat-error *ngIf="massCommunicationForm.controls.body.errors?.required">
                            This is required Field.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="mat-dialog-title mb-0 cws-header py-2">Attachments</div>
            <div class="col-12 pl-0 pb-3" class="fileAttachmentContainer">
                <div class="pb-2" *ngFor="let list of fileList; let i = index">
                    <span class="">
                         <span>{{list.name}}</span>
                    </span>
                     <span class="material-icons-outlined pointer-cursor mat-primary pl-2"
                     (click)="removeFileFromList(i)">close</span> 
                 </div>
                 
                 <div *ngIf="duplicateFiles">
                    <mat-error>Duplicate Files are not allowed.</mat-error>
                 </div>
                 <mat-error *ngIf="fileSizeValid">
                    Upload must be less than: {{ fileSize }}MB
                  </mat-error>
                  <mat-error *ngIf="extensionValid">
                    Not Valid File Extension
                  </mat-error>
            </div>
            <div class="col-12 pl-0 pt-2 pb-3 ppap-link" >
                <input type="file" formControlName="filesAttachment" id="filesUpload" (change)="onFileSelected($event)" style="display:none"/> 
                        <a (click)="fileUpload()" class="enable-icon underline sg-link-primary" *ngIf="!maxFileList">Add Attachment</a>
                        <a class="enable-icon underline" *ngIf="maxFileList"
                        [ngClass]="maxFileList ? 'disable-link' : ''">Add Attachment</a>
                <!-- <a  class="enable-icon underline sg-link-primary" (click)="onFileSelected($event)">Add Attachment</a> -->
            </div>
            <div *ngIf="maxFileList">
                <div class="ml-0 my-2 border rounded px-0" style="width: fit-content !important;">
                    <div class="row mx-0 pl-1 p-1 d-flex"> 
                       <div class="col-12 pl-0">
                        <span class="float-left material-icons-outlined py-0 pl-0 pr-1 sg-item-lead-info">info</span> 
                        <span class="d-flex pl-1 pr-0 pt-1 mr-0 font-weight-normal justify-content-center sg-item-lead-text"> 
                            You can upload a maximum of 3 files at a time
                        </span>
                    </div>   
                </div>
            </div>
             </div>
        </main>
        <div class="border-top row mx-0 justify-content-end" mat-dialog-actions>
            <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-4"
                type="button"
                [disabled]="massCommunicationForm.invalid"
                (click)="onSaveClick()">Send</button>
            <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button" type="button"
                (click)="onCancelClick()">Cancel</button>
        </div>
    </form>
</section>

<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
  </div>